import React, { useEffect, useState } from 'react'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { checkValid } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { deleteSupplyBillItemAPI } from '../../../../../api/supply/supplyBillItemAPI'
import { useDispatch } from 'react-redux'
import { deleteSupplyBillItem } from '../../../../../store/supplyBillSlice'

const DeleteBillItemForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    // const [data, setData] = useState(supplyBillItemBd ? {isAgreeEconomist: supplyBillItemBd.isAgreeEconomist} : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        deleteSupplyBillItemAPI({
            supplyBillItemId: supplyBillItemBd.id,
        }).then(data => {
            if (data) {
                dispatch(deleteSupplyBillItem(data))
            }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Ви впевнені, що хочете видалити позицію з рахунку?
            </p>
            <p>
                Кількість буде повернута у відповідну позицію в заявці
            </p>
            <p>
                <b>Важливо!</b> Позицію може видалити лише керівник, якщо є бодай якесь погодження
            </p>
        </div>
        
        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            color='red'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Видалити
        </MyButton>
    </div>
  )
}

export default DeleteBillItemForm